var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login-controller"}},[(!_vm.global.loggedIn)?_c('Login'):(['admin', 'sewist'].includes(_vm.global.accountType))?_c('Dashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }